import React from 'react';
// import './ScrollingText.css'; // Import the CSS file for styling

const ScrollingText = () => {
  return (
    <div className="scrolling-text-container">
      <div className="scroll-left">
        <p>
            This text will scroll continuously from left to right and then restart.
        </p>
      </div>
    </div>
  );
};

export default ScrollingText;
